import React, { useState, useEffect } from 'react';
import { adminApi } from '../../services/api';
import { PieChart, ShoppingCart, Truck, Euro, Clock } from 'lucide-react';

export default function AdminOrdersAnalytics() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/admin/orders/stats').then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-[#D44E20] border-t-transparent rounded-full animate-spin" /></div>;

  const cards = [
    { label: 'Ordini totali', value: stats?.total || 0, icon: ShoppingCart, color: '#D44E20' },
    { label: 'Take-Away', value: stats?.takeaway || 0, icon: ShoppingCart, color: '#E85D04' },
    { label: 'Delivery', value: stats?.delivery || 0, icon: Truck, color: '#6366F1' },
    { label: 'Revenue 30gg', value: `${(stats?.revenue_30d || 0).toFixed(2)}€`, icon: Euro, color: '#10B981' },
    { label: 'Ticket medio', value: `${(stats?.avg_order || 0).toFixed(2)}€`, icon: Euro, color: '#3B82F6' },
    { label: 'Tempo medio', value: `${stats?.avg_prep_min || 0} min`, icon: Clock, color: '#8B5CF6' },
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6" data-testid="orders-analytics-page">
      <div>
        <h1 className="text-2xl font-bold text-[#1A1A1A] flex items-center gap-2"><PieChart size={22} className="text-[#3B82F6]" /> Analisi Ordini</h1>
        <p className="text-sm text-[#64748B] mt-1">Performance take-away e delivery: volumi, revenue, ticket medio, tempi.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {cards.map(c => (
          <div key={c.label} className="bg-white rounded-2xl border border-slate-200/60 p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${c.color}15` }}>
                <c.icon size={18} style={{ color: c.color }} />
              </div>
              <div>
                <p className="text-[11px] text-[#64748B] font-medium">{c.label}</p>
                <p className="text-lg font-bold text-[#1A1A1A]">{c.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-xs text-blue-900">
        💡 <b>Suggerimento</b>: questa sezione mostra solo metriche di take-away e delivery. Per analisi merchandising e biglietti eventi vai su <b>Analisi Shop</b>; per loyalty/referral vai su <b>Analisi Loyalty</b>.
      </div>
    </div>
  );
}
